
 $( document ).ready(function() {
   if($('.new-design-collection .collection .top-filter').length > 0){
      var filter_offset = $('.new-design-collection .collection .top-filter').offset().top - 20
     //console.log('filter_offset:-' + filter_offset);
   
     $(window).scroll(function () {
       var filter_offset_onscroll = $('.new-design-collection .collection .top-filter').offset().top
       //console.log('filter_offset_onScroll:-' + filter_offset_onscroll);
       //console.log('window_offset_onScroll:-' + $(window).scrollTop());
  
        if ($(window).scrollTop() >= 1) {
              $('.new-design-collection .collection .top-filter').addClass('isSticky');
              $('.new-design-collection .collection .top-filter .collection_description').slideUp('400');
          } else {
              $('.new-design-collection .collection .top-filter').removeClass('isSticky');
            $('.new-design-collection .collection .top-filter .collection_description').slideDown('400');
          }
     });
   }

   
   if($(window).width() <= 767){
     $('.product-card__figure .product-card__media').slick({
          slidesToShow: 1,
          slidesToScroll: 1, 
          arrows: false,
          dots: true,
      });

     setTimeout(function(){
       $('.product-card__figure .product-card__media').slick({
          slidesToShow: 1,
          slidesToScroll: 1, 
          arrows: false,
          dots: true,
        });
     },600);
  }

   $(window).resize(function () {
      if($(window).width() <= 767){
           $('.product-card__figure .product-card__media').slick({
                slidesToShow: 1,
                slidesToScroll: 1, 
                arrows: false,
                dots: true,
            });
      
           setTimeout(function(){
             $('.product-card__figure .product-card__media').slick({
                slidesToShow: 1,
                slidesToScroll: 1, 
                arrows: false,
                dots: true,
              });
           },500);
        }
    });
   

   
// Ajax Add to cart Collection
   
$(document).on("click", ".accordion.group", function(e){  
   //e.preventDefault();

  if ($(this).hasClass('active-main')){
     $(this).attr("aria-expanded","false");
     $('.active-main .accordion__content').removeClass('active');
    $(this).removeClass('active-main');
  }else {
   // console.log('hello');
     $(this).attr("aria-expanded","true");
    $('.accordion').removeClass('active-main');
    $('.accordion__content').closest('.accordion__content').removeClass('active');
    $(this).addClass('active-main');
    $('.active-main .accordion__content').addClass('active');
  }
}); 

$(document).on("click", ".short_value_list li", function(e){ 
  var short_name = $(this).text();
  $('.active-short').text(short_name);
  var sortvalue = $(this).data('id');
  $('.popover__value-list .popover-listbox__option[value="'+sortvalue+'"]').click();
}); 

/* Product Details Page Price */   
 if ($('.price_cart').is(':empty')){
    var price_wrap = $('.product-info__block-item span.price-wrap').text();
    $('.price_cart').text(price_wrap);
    var price_html = $('.price_cart').html();
   var space_bar = "&nbsp;";  
   $('.Product__Info .button.button.w-full').append(space_bar, price_html);    
  }
});

$( ".variant-picker .variant-picker__option" ).on( "change", function() {
  updatePrice();
  setTimeout(function() {
    
    //updatePrice();
 
    if ($('.price_cart').is(':empty')){
      var price_html = $('.price_cart').html();
      var newPrice = price_html.replace(/[^0-9\.]/g, '');
      var questionText = price_html.replace(/\d+/g, '');
      var installments = newPrice / 4;
      if(questionText == '$.') {
            $('#afterpay-info .afterpay-instalments').text('$' + installments.toFixed(2));
      }else {
           // $('#afterpay-info .afterpay-instalments').text(questionText + installments.toFixed(2));
      }
      var space_bar = "&nbsp;";  
      $('.Product__Info .button.button.w-full').append(space_bar, price_html);  
    }else {
      var space_bar = "&nbsp;";  
        var price_html = $('.buy-buttons sale-price').html();
        var newPrice = price_html.replace(/[^0-9\.]/g, '');
     // console.log(newPrice);
        var questionText = price_html.replace(/\d+/g, '');
        var installments = newPrice / 4;
      // console.log(installments);
        if(questionText == '$.') {
              $('#afterpay-info .afterpay-instalments').text('$' + installments.toFixed(2));
        }else {
              //$('#afterpay-info .afterpay-instalments').text(questionText + installments.toFixed(2));
        }
      var price_set = price_html.replace('.00', '');
      $('.Product__Info .button.button.w-full').append(space_bar, price_set);  
    }  
    if($(".Product__Info .button.button.w-full").attr('disabled')) {
        $('.Product__Info a.notify-link').show();
    }else {
         $('.Product__Info a.notify-link').hide();
    }
  }, 500);  
});

$(document).on("click", ".quick-buy-modal__content button.select", function(e){
  setTimeout(function() {
    updatePrice();
    }, 400);  
});

function updatePrice(){
var prices = document.querySelectorAll('.remove_maths');
  if (!prices)return;
  for (var each of prices){
    each.innerText = each.innerText.replace('.00', '');
  }
}
/* Size Chart product page */
  setTimeout(function () {
    $(document).on('click', "#size-chart-size-guide", function (e) {
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: '#size-chart-size-guide-popup'
        },
        type: 'inline',
        closeOnBgClick: true,
        closeBtnInside:true,
        enableEscapeKey: true,
        mainClass: 'mfp-fade',
        removalDelay: 300
      }, 0);
    });
 $('.tabs-stage-size-guide div').hide();
    $('.tabs-stage-size-guide div:first').show();
    $('.tabs-nav-size-guide li:first').addClass('tab-active-size-guide');

    $('.tabs-nav-size-guide a').on('click', function(event){
      event.preventDefault();
      $('.tabs-nav-size-guide li').removeClass('tab-active-size-guide');
      $(this).parent().addClass('tab-active-size-guide');
      $('.tabs-stage-size-guide div').hide();
      $($(this).attr('href')).show();
    });
  }, 2000);

 $('.size_chart_link').on('click', function() {    
    if($('.size_chart_link.active').length > 0) {
      var active_size = $('.size_chart_link.active').attr('id');
      $('#'+active_size).removeClass('active');
      $('#'+active_size+'_content_cm').addClass('hidden');
      $('#'+active_size+'_content_inch').addClass('hidden');

      var class_selected = $(this).attr('id');
      $(this).addClass('active');
      $('#'+class_selected+'_content_cm').removeClass('hidden');
      $('#'+class_selected+'_content_inch').removeClass('hidden');
    } 
  });

  $('#units_sizechart_inches').on('click', function() {  
    
    $('.container_right_sizechart.content_cm').addClass('hidden');
    $('.container_right_sizechart.content_inches').removeClass('hidden');
    
    $('#units_sizechart_cm').removeClass('bold');
    $('#units_sizechart_inches').addClass('bold');
  });
  
  $('#units_sizechart_cm').on('click', function() {
    
    $('.container_right_sizechart.content_cm').removeClass('hidden');
    $('.container_right_sizechart.content_inches').addClass('hidden');
    
    $('#units_sizechart_cm').addClass('bold');
    $('#units_sizechart_inches').removeClass('bold');
  });


// Color Option Toggle
$(document).on("click", ".Collapsible--large .bordered-product-tab", function(e){
  $(this).toggleClass('active');
  $('.Collapsible--large .Collapsible__Inner').toggleClass('active');
})

//jQuery Click Outside Div
$(document).mouseup(function (e) {
  if ($(e.target).closest(".accordion-list").length=== 0) {
    $(".accordion-list .accordion__content").removeClass('active');
    $(".accordion").removeClass('active-main');
  }
});

//$('.product-card__figure .quick-add-btn').click(function() {
  //$(this).toggleClass('isClicked');
  //$(this).next('.hover-option').show();
//});


function isTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}

if(isTouchDevice()===true) {
    $(".ProductForm__Option .Collapsible__Inner .desktop_color_var").hide();

    $(document).on("click", ".Collapsible--large .bordered-product-tab", function(e){
      $('html').addClass('lock');
      $('.Collapsible__Inner .mobile_color_Var .mobile_color_Var_content').addClass('isAnimte');
    });    

    $('.mobile_color_Var_overlay, .mobile_color_Var .mobile_color_Var_content .content-head .close-btn').click(function(){
      $('html').removeClass('lock');
      $('.ProductForm__Option .Collapsible__Inner').removeClass('active');
      $('.Collapsible__Inner .mobile_color_Var .mobile_color_Var_content').removeClass('isAnimte');
    });
  
  
    //alert('Touch Device'); //your logic for touch device
    $(document).on("click", ".product-card__figure .quick-add-btn", function(e){
      $(this).toggleClass('active');
      $(this).next('.hover-option').slideToggle();
      $(this).parents('.product-card__figure').toggleClass('isHoverd');          
    });

    $(document).on("click", ".single_product_option .single_quick_add", function(e){
      $(this).toggleClass('active');
      $(this).parents('.product-card__figure').toggleClass('isHoverd_desktop');          
    });

    $(document).on("click", ".single_product_option .select-label-wrap", function(e){
      $(".single_product_option .single_quick_add").removeClass('active');
      $(this).parents('.product-card__figure').removeClass('isHoverd_desktop');          
    });
}
else {

  $(".ProductForm__Option .Collapsible__Inner .mobile_color_Var").hide();
    //alert('Not a Touch Device'); //your logic for non touch device
  /*$(".product-card__figure .quick-add-btn, .product-card__figure .hover-option").hover(function(event){
          $(this).addClass('active');
          $(this).parents('.product-card__figure').addClass('isHoverd');
          event.preventDefault()
        }, function(){
          $(this).removeClass('active');
          $(this).parents('.product-card__figure').removeClass('isHoverd');
          event.preventDefault()
      });*/

  $(document).on('mouseenter', '.product-card__figure .quick-add-btn, .product-card__figure .hover-option', function(event) {
      $(this).addClass('active');
      $(this).parents('.product-card__figure').addClass('isHoverd');
    $(this).parents('.product-card__figure').addClass('isHoverd_desktop');
      event.preventDefault()
    }).on("mouseleave", ".product-card__figure .quick-add-btn, .product-card__figure .hover-option", function(event){
        $(this).removeClass('active');
        $(this).parents('.product-card__figure').removeClass('isHoverd');
        $(this).parents('.product-card__figure').removeClass('isHoverd_desktop');
        event.preventDefault()
    });


    $(document).on('mouseenter', '.single_product_option', function(event) {
      $(this).addClass('active');
      $(this).parents('.product-card__figure').addClass('isHoverd');
      $(this).parents('.product-card__figure').addClass('isHoverd_desktop');
      //event.preventDefault()
    }).on("mouseleave", ".single_product_option", function(event){
        $(this).removeClass('active');
        $(this).parents('.product-card__figure').removeClass('isHoverd');
        $(this).parents('.product-card__figure').removeClass('isHoverd_desktop');
        //event.preventDefault()
    });
}


/*$(document).on("click", ".product-card__figure .quick-add-btn", function(e){
    $(this).toggleClass('active');
    $(this).next('.hover-option').slideToggle();
    $(this).parents('.product-card__figure').toggleClass('isHoverd');
});*/



/*$(".product-card__figure .quick-add-btn, .product-card__figure .hover-option").hover(function(event){
    $(this).addClass('active');
    $(this).parents('.product-card__figure').addClass('isHoverd');
    event.preventDefault()
  }, function(){
    $(this).removeClass('active');
    $(this).parents('.product-card__figure').removeClass('isHoverd');
    event.preventDefault()
});*/

$(document).on("click", ".custom-accordion .accordion-block .acc-title", function(e){
  $(this).toggleClass('active');
  $(this).next('.acc-content').slideToggle();
});



//Popup Price
// $(document).on("click", ".horizontal-product-card__info x-listbox.popover__value-list", function(e){
//   alert();
// });
// $(document).on("change", ".popover.popover--bottom-start", function(e){
//   setTimeout(function() {
//     alert('sd');
//     //updatePrice();
 
//     if ($('.quick-buy-modal__content .buy-buttons .text-on-sale').is(':empty')){
//       var price_html = $('.quick-buy-modal__content .buy-buttons .text-on-sale').html();;
//       var space_bar = "&nbsp;";  
//       $('.quick-buy-modal__content .button.button.w-full').append(space_bar, price_html);  
//     }else {
//       var space_bar = "&nbsp;";  
//       var price_html = $('.buy-buttons sale-price').html();
//       var price_set = price_html.replace('.00', '');
//       $('.button.button.w-full').append(space_bar, price_set);  
//     }  
//   }, 500);  
// });
